/**
 * this file contains all the endpoints
 *
 * Created by Tom on 18/06/18
 */

const config = {
    "endpoints" : {

        // dev & prod base URL
        "baseUrlDev" : "http://smsf-proxy.cloudhub.io/class/fund/DEMO_SMSF/fetch/",
        "baseUrlProd" : "",

        // fetch url for the list of transactions
        "transactionFetchURL" : "http://smsf-proxy.cloudhub.io/class/fund/DEMO_SMSF/fetch/transaction_amount/2018-05-05/2018-05-10?client_id=84c2c79aa9194a2ea1581a5adf4f3b4c&client_secret=C48231B007524550a571c1b0Ee2A0Da2"
    }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js